import { WSService } from "../../../utils/WSService";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";

const service = new WSService("/v2/onboarding/customer");

export const getCustomerEntity = async (): Promise<
  onboardingApiSpec.operations["getCustomerEntity"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.get("");
  return data;
};

export const createCustomerEntity = async (
  requestData: onboardingApiSpec.CustomerEntity
): Promise<
  onboardingApiSpec.operations["createCustomerEntity"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.post("", requestData);
  return data;
};

export const updateCustomerData = async (
  relationshipType: onboardingApiSpec.operations["updateCustomerData"]["parameters"]["path"]["relationshipType"],
  requestData: onboardingApiSpec.operations["updateCustomerData"]["requestBody"]["content"]["application/json"]
): Promise<
  onboardingApiSpec.operations["updateCustomerData"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.patch("/" + relationshipType, requestData);
  return data;
};

export const requestCustomerEntityChange = async (
  requestData: onboardingApiSpec.CustomerEntityChangeRequest
): Promise<
  onboardingApiSpec.operations["requestCustomerEntityChange"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.post("/change-request", requestData);
  return data;
};
